import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button, Form, InputGroup, Modal, Nav, Spinner } from 'react-bootstrap'
import DataTable from 'react-data-table-component';
import { RiArrowDownSLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { BsThreeDots } from "react-icons/bs";
import { approveOrder, deleteOrderItem, downloadBulkOrderInvoice, downloadOrdersExcelSheet, getCompletedOrdersListing, getOrdersListing, getRejectedOrdersListing, rejectOrder } from '../../api/context/orders';
import Loader from '../../components/loader/loader';
import { Box, Paper, Tooltip } from "@mui/material";
import moment from 'moment';
import ordernew from '../../assets/images/order-new.png';
import orderexchange from '../../assets/images/order-exchange.png';
import orderreturn from '../../assets/images/order-return.png';
import CustomisedModal from '../../components/Modal/CustomisedModal';
import Select from 'react-select'
import { useFormik } from 'formik'
import Offcanvas from 'react-bootstrap/Offcanvas';

import { useRecoilState } from 'recoil';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { SelectionContext } from '../../Context/Store';
import toast from 'react-hot-toast';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { FaDownload, FaFile, FaJediOrder } from "react-icons/fa6";
import { getBrandListing } from "../../api/context/brand";
import BulkInvoiceModal from './BulkOrderInvoice';
import { getManufacturesListingPaginate } from '../../api/context/manufacturer';
import { FiAlertTriangle, FiDownload, FiFile, FiFilter, FiImage, FiPlayCircle, FiX } from 'react-icons/fi';
import OrderFilterModal from './helpers/OrderFilterModal';
import { orderListFilter, orderPaginationState } from '../../atoms/orderListFilter';

// Extend dayjs with the plugins
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);


const queueDatatableCustomStyles = {
  headRow: {
    style: {
      backgroundColor: '#f8fafc',
      borderBottom: '1px solid #e2e8f0',
      minHeight: '48px',
    },
  },
  headCells: {
    style: {
      display: 'flex',
      justifyContent: 'center',
      fontWeight: '600',
      fontSize: '9px',
      padding: '10px 6px',
      color: '#475569',
      textTransform: 'uppercase',
      letterSpacing: '0.02em',
      backgroundColor: '#f8fafc',
    },
  },
  cells: {
    style: {
      display: 'flex',
      fontSize: '10px',
      fontWeight: '500',
      color: '#0f172a',
      padding: '10px 6px',
    },
  },
  rows: {
    style: {
      minHeight: '48px',
      borderBottom: '1px solid #eef2f7',
      transition: 'background 0.15s ease',
      '&:not(:last-of-type)': {
        borderBottom: '1px solid #eef2f7',
      },
      '&:hover': {
        backgroundColor: '#f8fafc !important',
        cursor: 'pointer',
      },
    },
  },
  pagination: {
    style: {
      borderTop: '1px solid #eef2f7',
      minHeight: '52px',
      fontSize: '12px',
      color: '#475569',
    },
  },
};


const Orders = () => {

  const navigate = useNavigate()

  const { ordersTrigger, setOrdersTrigger } = useContext(SelectionContext)



  const [orders, setOrders] = useState([]);
  // const [completedorders, setCompletedOrders] = useState([]);
  // const [rejectedorders, setRejectedOrders] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  const [filterData, setFilterData] = useRecoilState(orderListFilter);
  const [pagination, setPagination] = useRecoilState(orderPaginationState);

  const { page, limit } = pagination;

  // const [totalActiveRows, setTotalActiveRows] = useState(0);
  // const [totalInActiveRows, setTotalInActiveRows] = useState(0);
  const [limitactive, setLimitActive] = useState(10);
  const [pageactive, setPageActive] = useState(1);
  const [limitinactive, setLimitInactive] = useState(10);
  const [pageinactive, setPageInactive] = useState(1);
  const [initial, setInitial] = useState(false);

  const [showFilters, setShowFilters] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [modal, setModal] = useState(false);
  const [deletingId, setDeletingId] = useState("");
  const [filter, setFilter] = useState("all");
  const [show, setShow] = useState(false);
  const [checkoutErrorShown, setCheckoutErrorShown] = useState(false);
  const [downloadOrdersExcel, setDownloadOrdersExcel] = useState(false);
  const [totalOrdesToDownload, setTotalOrdersToDownload] = useState([]);
  const [limitDownloadOrders, setLimitDownloadOrders] = useState(5);
  const [isInitialRender, setIsInitialRender] = useState(true);
  const typingRef = useRef(null);

  const [brands, setBrands] = useState([]);
  const [pageBrands, setPageBrands] = useState(1);
  const [hasMoreBrands, setHasMoreBrands] = useState(true);
  const [brandSearch, setBrandSearch] = useState('');

  const [hasMore, setHasMore] = useState(true);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleShowFilters = () => setShowFilters(true);
  const handleCloseFilters = () => setShowFilters(false);

  const [bulkInvoiceModal, setBulkInvoiceModal] = useState(false);
  const [bulkVendors, setBulkVendors] = useState([]);
  const [bulkStartDate, setBulkStartDate] = useState(null);
  const [bulkEndDate, setBulkEndDate] = useState(null);
  const [downloadingBulkInvoice, setDownloadingBulkInvoice] = useState(false);
  const [manufacturers, setManufacturers] = useState([]);
  const [hasMoreManufacture, setHasMoreManufacture] = useState(true);

  // Live-order actions state (mirrors the Dashboard Live Orders table)
  const [orderActionLoadingId, setOrderActionLoadingId] = useState(null);
  const [orderActionLoadingType, setOrderActionLoadingType] = useState(null);
  const [showRejectConfirm, setShowRejectConfirm] = useState(false);
  const [pendingRejectOrder, setPendingRejectOrder] = useState(null);
  const [showApproveConfirm, setShowApproveConfirm] = useState(false);
  const [pendingApproveOrder, setPendingApproveOrder] = useState(null);
  const [showEvidenceModal, setShowEvidenceModal] = useState(false);
  const [evidenceOrder, setEvidenceOrder] = useState(null);
  const [evidenceVideoUrl, setEvidenceVideoUrl] = useState(null);
  const [evidenceReturnReason, setEvidenceReturnReason] = useState('');
  const [evidenceReturnComments, setEvidenceReturnComments] = useState('');
  const [showVideoPreview, setShowVideoPreview] = useState(false);
  const [videoPreviewData, setVideoPreviewData] = useState({ videoUrl: null, reason: '', comments: '', orderId: '', orderType: null, row: null });
  const [rejectionReason, setRejectionReason] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [evidenceLoading, setEvidenceLoading] = useState(false);
  const [evidenceAction, setEvidenceAction] = useState(null); // 'REJECT' | 'APPROVE'

  const EVIDENCE_REJECTION_REASONS = [
    "Product damaged by customer",
    "Wrong product returned",
    "Return period expired",
    "Missing original packaging",
    "Product used/worn",
  ];



  const orderTypeOptions = [
    { value: null, label: 'NEW' },
    { value: 1, label: 'RETURN' },
    { value: 2, label: 'EXCHANGE' }
  ]
  const orderStatusOptions = [
    { value: 'INITIATED', label: 'INITIATED' },
    { value: 'CANCELLED', label: 'CANCELLED' },
    { value: 'CONFIRMED', label: 'CONFIRMED' },
    { value: 'DELIVERED', label: 'DELIVERED' },
    { value: 'REJECTED', label: 'REJECTED' }
  ]

  const paymentModeOptions = [
    { value: "COD", label: 'COD' },
    { value: "ONLINE", label: 'ONLINE' },
  ]

  const paymentStatusOptions = [
    { value: "PENDING", label: 'PENDING' },
    { value: "DONE", label: 'DONE' },
  ]

  const statusChipStyle = (bg, color = '#fff') => ({
    display: 'inline-block',
    backgroundColor: bg,
    color,
    padding: '3px 8px',
    borderRadius: '4px',
    fontWeight: 600,
    fontSize: '10px',
    letterSpacing: '0.01em',
    whiteSpace: 'nowrap',
  });

  const isOnlinePaymentPending = (order) => (
    order?.paymentMode === 'ONLINE' && order?.paymentStatus === 'PENDING'
  );

  const formatINR = (v) => {
    const n = Number(v || 0);
    return n.toLocaleString('en-IN', { maximumFractionDigits: 0 });
  };

  const refreshOrdersSilent = () => {
    // Trigger a silent re-fetch of the current filtered list
    fetchOrdersData(filter);
  };

  const handleLiveOrderStatus = (order, status) => {
    if (!order?.id || orderActionLoadingId) return;
    const isReject = status === 'REJECTED';

    if (isReject) {
      setPendingRejectOrder(order);
      setRejectionReason('');
      setCustomReason('');
      setShowRejectConfirm(true);
      return;
    }

    // Approve flow — show product-review modal first
    setPendingApproveOrder(order);
    setShowApproveConfirm(true);
  };

  const confirmApproveOrder = () => {
    if (!pendingApproveOrder?.id || orderActionLoadingId) return;

    setOrderActionLoadingId(pendingApproveOrder.id);
    setOrderActionLoadingType('ACCEPT');
    approveOrder({ orderIds: [pendingApproveOrder.id], status: 'CONFIRMED' })((response) => {
      if (response?.data?.statusCode === 200) {
        toast.success(response.data.message || 'Order accepted successfully');
        refreshOrdersSilent();
      } else {
        toast.error(response?.data?.message || 'Something went wrong');
      }
      setOrderActionLoadingId(null);
      setOrderActionLoadingType(null);
      setPendingApproveOrder(null);
      setShowApproveConfirm(false);
    });
  };

  const confirmRejectOrder = () => {
    if (!pendingRejectOrder?.id || orderActionLoadingId) return;

    const needsReason = pendingRejectOrder?.orderType === 1 || pendingRejectOrder?.orderType === 2;
    const payload = { orderIds: [pendingRejectOrder.id] };

    if (needsReason) {
      let finalReason = rejectionReason;
      if (!rejectionReason && customReason && customReason.trim().length >= 10) {
        finalReason = customReason.trim();
      } else if (!rejectionReason) {
        toast.error('Please select a reason or provide a custom reason (min. 10 characters)');
        return;
      }
      payload.reason = finalReason;
    }

    setOrderActionLoadingId(pendingRejectOrder.id);
    setOrderActionLoadingType('REJECT');
    rejectOrder(payload)((response) => {
      if (response?.data?.statusCode === 200) {
        toast.success(response.data.message || 'Order rejected successfully');
        refreshOrdersSilent();
      } else {
        toast.error(response?.data?.message || 'Something went wrong');
      }
      setOrderActionLoadingId(null);
      setOrderActionLoadingType(null);
      setPendingRejectOrder(null);
      setRejectionReason('');
      setCustomReason('');
      setShowRejectConfirm(false);
    });
  };

  const getEvidenceInfoFromOrder = (order) => {
    const pickFromProducts = (products) => {
      if (!Array.isArray(products)) return null;
      for (const p of products) {
        const returns = p?.returns || [];
        for (const r of returns) {
          const video = (r?.returnImages || []).find(img => img?.mediaType === 'video');
          if (video?.mediaUrl || r?.reason || r?.comments) {
            return { videoUrl: video?.mediaUrl || null, reason: r?.reason || '', comments: r?.comments || '' };
          }
        }
      }
      return null;
    };
    return pickFromProducts(order?.orderProducts) || pickFromProducts(order?.baseOrder?.orderProducts) || { videoUrl: null, reason: '', comments: '' };
  };

  const getEvidenceVideoFromOrder = (order) => getEvidenceInfoFromOrder(order)?.videoUrl || null;

  const openEvidenceModal = (row) => {
    setEvidenceOrder(row);
    const info = getEvidenceInfoFromOrder(row);
    setEvidenceVideoUrl(info?.videoUrl || null);
    setEvidenceReturnReason(info?.reason || '');
    setEvidenceReturnComments(info?.comments || '');
    setRejectionReason('');
    setCustomReason('');
    setShowEvidenceModal(true);
  };

  const openVideoPreview = (row) => {
    const info = getEvidenceInfoFromOrder(row);
    setVideoPreviewData({
      videoUrl: info?.videoUrl || null,
      reason: info?.reason || '',
      comments: info?.comments || '',
      orderId: row?.orderId || '',
      orderType: row?.orderType || null,
      row,
    });
    setShowVideoPreview(true);
  };

  const closeVideoPreview = () => {
    setShowVideoPreview(false);
    setVideoPreviewData({ videoUrl: null, reason: '', comments: '', orderId: '', orderType: null, row: null });
  };

  const handleVideoPreviewAccept = () => {
    const row = videoPreviewData?.row;
    if (!row) return;
    setShowVideoPreview(false);
    setVideoPreviewData({ videoUrl: null, reason: '', comments: '', orderId: '', orderType: null, row: null });
    handleLiveOrderStatus(row, 'CONFIRMED');
  };

  const handleVideoPreviewReject = () => {
    const row = videoPreviewData?.row;
    if (!row) return;
    setShowVideoPreview(false);
    setVideoPreviewData({ videoUrl: null, reason: '', comments: '', orderId: '', orderType: null, row: null });
    handleLiveOrderStatus(row, 'REJECTED');
  };

  const closeEvidenceModal = () => {
    if (evidenceLoading) return;
    setShowEvidenceModal(false);
    setEvidenceOrder(null);
    setEvidenceVideoUrl(null);
    setEvidenceReturnReason('');
    setEvidenceReturnComments('');
    setRejectionReason('');
    setCustomReason('');
  };

  const handleEvidenceReject = () => {
    const orderId = evidenceOrder?.id;
    if (!orderId || evidenceLoading) return;
    let finalReason = rejectionReason;
    if (!rejectionReason && customReason && customReason.trim().length >= 10) {
      finalReason = customReason.trim();
    } else if (!rejectionReason) {
      toast.error("Please select a reason or provide a custom reason (min. 10 characters)");
      return;
    }
    setEvidenceAction('REJECT');
    setEvidenceLoading(true);
    rejectOrder({ orderIds: [orderId], reason: finalReason })((response) => {
      if (response?.data?.statusCode === 200) {
        toast.success(response?.data?.message || "Order rejected successfully");
        setShowEvidenceModal(false);
        setEvidenceOrder(null);
        setEvidenceVideoUrl(null);
        setRejectionReason('');
        setCustomReason('');
        refreshOrdersSilent();
      } else {
        toast.error(response?.data?.message || "Something went wrong");
      }
      setEvidenceLoading(false);
      setEvidenceAction(null);
    });
  };

  const handleEvidenceApprove = () => {
    const orderId = evidenceOrder?.id;
    if (!orderId || evidenceLoading) return;
    setEvidenceAction('APPROVE');
    setEvidenceLoading(true);
    approveOrder({ orderIds: [orderId], status: 'CONFIRMED' })((response) => {
      if (response?.data?.statusCode === 200) {
        toast.success(response?.data?.message || "Order accepted successfully");
        setShowEvidenceModal(false);
        setEvidenceOrder(null);
        setEvidenceVideoUrl(null);
        setRejectionReason('');
        setCustomReason('');
        refreshOrdersSilent();
      } else {
        toast.error(response?.data?.message || "Something went wrong");
      }
      setEvidenceLoading(false);
      setEvidenceAction(null);
    });
  };

  const renderLiveOrderActions = (row, compact = false) => {
    const type = row?.orderType;
    const status = row?.status;
    const pendingOnlinePayment = isOnlinePaymentPending(row);
    const isLoading = orderActionLoadingId === row?.id;
    const isRejectLoading = isLoading && orderActionLoadingType === 'REJECT';
    const isAcceptLoading = isLoading && orderActionLoadingType === 'ACCEPT';
    const pickupOtp = row?.pidgeOrder?.pickupOtp;
    const dropOtp = row?.pidgeOrder?.dropOtp;
    const showConfirmReject = status === 'INITIATED' && (type === null || type === undefined);
    const showReturnEvidence = status === 'INITIATED' && type === 1;
    const showExchangeActions = status === 'INITIATED' && type === 2;
    const showEvidence = showReturnEvidence; // legacy alias used below
    const isExchange = type === 2;
    const statusForExchange = row?.statusForExchangeOrder;
    const showPickupOtp = status === 'CONFIRMED' && !!pickupOtp && (
      isExchange
        ? statusForExchange === 2
        : ((type === null || type === undefined) && row?.deliveryStatus === 'PENDING')
    );
    const showDropOtp = status === 'CONFIRMED' && !!dropOtp && (
      isExchange
        ? statusForExchange === 1
        : (type === 1 && row?.deliveryStatus === 'DISPATCHED')
    );

    if (!showConfirmReject && !showEvidence && !showExchangeActions && !showPickupOtp && !showDropOtp) return null;

    const buttonStyle = {
      border: '1px solid transparent',
      borderRadius: compact ? 8 : 6,
      padding: compact ? '10px 14px' : '7px 12px',
      fontSize: compact ? '12px' : '11px',
      fontWeight: 800,
      lineHeight: 1.2,
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      width: compact ? '100%' : 'auto',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: compact ? 40 : 30,
      textAlign: 'center',
      letterSpacing: '0.01em',
      boxShadow: '0 1px 2px rgba(15, 23, 42, 0.08)',
    };
    const loadingActionStyle = {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 6,
    };
    const stableActionBtn = compact ? { flex: 1 } : { minWidth: 72, width: 72, flex: '0 0 auto' };
    const stop = (event) => event.stopPropagation();
    const otpStyle = {
      ...statusChipStyle('#e0f2fe', '#075985'),
      fontSize: compact ? '15px' : '11px',
      fontWeight: 800,
      padding: compact ? '10px 12px' : '5px 9px',
      width: compact ? '100%' : 'auto',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      letterSpacing: '0.02em',
    };
    const actionWrapStyle = compact
      ? { display: 'flex', flexDirection: 'column', gap: 6, width: '100%' }
      : { display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 5, flexWrap: 'wrap' };

    return (
      <div onClick={stop} style={actionWrapStyle}>
        {showPickupOtp && (
          <span title="Share with the pickup driver" style={{ ...otpStyle, background: '#e0f2fe', color: '#075985' }}>
            Pickup OTP: {pickupOtp}
          </span>
        )}
        {showDropOtp && (
          <span title="Share with the delivery driver" style={{ ...otpStyle, background: '#fee2e2', color: '#b91c1c' }}>
            Drop OTP: {dropOtp}
          </span>
        )}
        {showEvidence && (
          <button type="button" style={{ ...buttonStyle, background: '#0e7490', color: '#fff' }} disabled={pendingOnlinePayment || isLoading}
            onClick={() => openVideoPreview(row)}>
            {pendingOnlinePayment ? 'Waiting for Payment' : 'Check Evidence'}
          </button>
        )}
        {showConfirmReject && (
          <div style={compact ? { display: 'flex', gap: 6, width: '100%' } : { display: 'flex', alignItems: 'center', gap: 5, flexWrap: 'nowrap' }}>
            <button type="button" style={{ ...buttonStyle, ...stableActionBtn, background: '#fff1f2', borderColor: '#fecdd3', color: '#be123c', opacity: isRejectLoading ? 0.6 : 1 }} disabled={isLoading || Boolean(orderActionLoadingId)}
              onClick={() => handleLiveOrderStatus(row, 'REJECTED')}>
              {isRejectLoading ? (
                <span style={loadingActionStyle}><Spinner as="span" animation="border" size="sm" /></span>
              ) : 'Reject'}
            </button>
            <button type="button" style={{ ...buttonStyle, ...stableActionBtn, background: '#ccfbf1', borderColor: '#99f6e4', color: '#0f766e', opacity: pendingOnlinePayment || isAcceptLoading || Boolean(orderActionLoadingId) ? 0.6 : 1 }} disabled={pendingOnlinePayment || isLoading || Boolean(orderActionLoadingId)}
              onClick={() => handleLiveOrderStatus(row, 'CONFIRMED')}>
              {isAcceptLoading ? (
                <span style={loadingActionStyle}><Spinner as="span" animation="border" size="sm" /></span>
              ) : pendingOnlinePayment ? 'Waiting for Payment' : 'Accept'}
            </button>
          </div>
        )}
        {showExchangeActions && (
          <button type="button" style={{ ...buttonStyle, background: '#0e7490', color: '#fff' }} disabled={pendingOnlinePayment || isLoading}
            onClick={() => openVideoPreview(row)}>
            {pendingOnlinePayment ? 'Waiting for Payment' : 'Check Evidence'}
          </button>
        )}
      </div>
    );
  };

  const columns = [
    {
      id: 'product',
      name: 'Product',
      cell: (row) => {
        const products = row?.orderProducts || [];
        const firstImg = products.find(p => p?.Product?.thumbnailImageUrl)?.Product?.thumbnailImageUrl;
        const extra = products.length > 1 ? products.length - 1 : 0;
        const needsAction = row?.status === 'INITIATED';
        return (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            {firstImg ? (
              <img
                src={firstImg}
                alt="product"
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 4,
                  objectFit: 'cover',
                  border: '1px solid #e2e8f0',
                  background: '#f8fafc',
                }}
                onError={(e) => { e.currentTarget.style.display = 'none'; }}
              />
            ) : (
              <div
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 4,
                  background: '#f1f5f9',
                  border: '1px solid #e2e8f0',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#94a3b8',
                  fontSize: 8,
                  fontWeight: 600,
                }}
              >
                N/A
              </div>
            )}
            {extra > 0 && (
              <span
                style={{
                  position: 'absolute',
                  top: needsAction ? undefined : -4,
                  bottom: needsAction ? -4 : undefined,
                  right: -6,
                  minWidth: 14,
                  height: 14,
                  padding: '0 3px',
                  background: '#0f172a',
                  color: '#fff',
                  fontSize: 9,
                  fontWeight: 700,
                  borderRadius: 999,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  lineHeight: 1,
                }}
              >
                +{extra}
              </span>
            )}
            {needsAction && (
              <span
                className="action-required-icon"
                style={{ position: 'absolute', top: -5, right: -5, width: 15, height: 15 }}
                aria-label="Action required"
                title="Action required"
              >
                <FiAlertTriangle size={9} strokeWidth={3} />
              </span>
            )}
          </div>
        );
      },
      grow: 0.4,
      minWidth: '70px',
      ignoreRowClick: false,
      style: { paddingLeft: '16px', justifyContent: 'flex-start' },
    },
    {
      id: 'orderId',
      name: 'Order Id',
      selector: (row) => row?.orderId,
      cell: (row) => (
        <Tooltip title={row?.orderId} disableInteractive placement="top">
          <div
            style={{
              backgroundColor: row?.isScheduled ? '#fef3c7' : '#f1f5f9',
              color: row?.isScheduled ? '#92400e' : '#0f172a',
              padding: '3px 8px',
              borderRadius: '4px',
              fontWeight: 600,
              fontSize: '10px',
              cursor: 'pointer',
              textAlign: 'center',
              border: row?.isScheduled ? '1px solid #fbbf24' : '1px solid transparent',
              maxWidth: '140px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/orderdetails/${row.id}`);
            }}
          >
            {row?.orderId}
          </div>
        </Tooltip>
      ),
      grow: 1.3,
      minWidth: '130px',
      center: true,
    },
    {
      name: 'Status',
      cell: (row) => {
        const status = row?.status;
        let bg = '#334155', color = '#fff';
        switch (status) {
          case 'CANCELLED': bg = '#dc2626'; color = '#fff'; break;
          case 'INITIATED': bg = '#facc15'; color = '#0f172a'; break;
          case 'CONFIRMED': bg = '#0e7490'; color = '#fff'; break;
          case 'DELIVERED': bg = '#10b981'; color = '#fff'; break;
          case 'REJECTED': bg = '#dc2626'; color = '#fff'; break;
          default: bg = '#6d28d9'; color = '#fff';
        }
        return status ? (
          <span style={statusChipStyle(bg, color)}>
            {status.toLowerCase().split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')}
          </span>
        ) : <span style={{ color: '#94a3b8' }}>N/A</span>;
      },
      sortable: true,
      center: true,
      grow: 0.9,
      minWidth: '100px',
      selector: (row) => row.status,
    },
    {
      id: 'createdAt',
      name: 'Date',
      selector: (row) => moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a'),
      cell: (row) => (
        <Tooltip title={moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement="top">
          <div style={{ color: '#475569', fontSize: '10px', whiteSpace: 'nowrap' }}>
            {moment(row?.createdAt).format('DD/MM/YY, hh:mm a')}
          </div>
        </Tooltip>
      ),
      grow: 1.1,
      minWidth: '120px',
      center: true,
    },
    {
      id: 'orderType',
      name: 'Type',
      selector: (row) => row?.orderType,
      cell: (row) => {
        const t = row?.orderType;
        const sfe = row?.statusForExchangeOrder;
        let label;
        if (t === 3) label = 'Delivered';
        else if (t === 2) label = sfe === 1 ? 'EXCHANGE_RETURN' : sfe === 2 ? 'EXCHANGE_DELIVERY' : 'Exchange';
        else if (t === 1) label = 'Return';
        else label = 'New';
        let bg = '#e0f2fe', color = '#0369a1';
        if (t === 1) { bg = '#fee2e2'; color = '#b91c1c'; }
        else if (t === 2) {
          if (sfe === 1) { bg = '#fef3c7'; color = '#92400e'; }
          else if (sfe === 2) { bg = '#dbeafe'; color = '#1d4ed8'; }
          else { bg = '#ede9fe'; color = '#6d28d9'; }
        }
        else if (t === 3) { bg = '#dcfce7'; color = '#166534'; }
        return (
          <span style={{
            display: 'inline-block',
            backgroundColor: bg,
            color,
            padding: '3px 10px',
            borderRadius: '999px',
            fontSize: '10px',
            fontWeight: 600,
            whiteSpace: 'nowrap',
          }}>
            {label}
          </span>
        );
      },
      center: true,
      grow: 1.2,
      minWidth: '150px',
    },
    // {
    //   id: 'isScheduled',
    //   name: 'Scheduled',
    //   selector: (row) => row?.isScheduled,
    //   cell: (row) => (
    //     row?.isScheduled ? (
    //       <span style={statusChipStyle('#dcfce7', '#166534')}>Scheduled</span>
    //     ) : (
    //       <span style={{ color: '#94a3b8', fontSize: '10px' }}>—</span>
    //     )
    //   ),
    //   center: true,
    //   grow: 0.7,
    //   minWidth: '90px',
    // }, 
    { 
      id: 'amount',
      name: 'Amount',
      selector: (row) => userType === 'ADMIN' ? row?.amount : row?.billingAmount,
      cell: (row) => {
        const amt = userType === 'ADMIN' ? row?.amount : row?.billingAmount;
        return (
          <Tooltip title={amt} disableInteractive placement="top">
            <div style={{ fontWeight: 700, color: '#0f172a', fontSize: '11px' }}>
              ₹{amt}
            </div>
          </Tooltip>
        );
      },
      center: true,
      grow: 0.6,
      minWidth: '80px',
    },
    {
      name: 'Payment Status',
      cell: (row) => {
        const status = row?.paymentStatus;
        if (!status) return <span style={{ color: '#94a3b8' }}>N/A</span>;
        const done = status === 'DONE';
        return (
          <span style={statusChipStyle(done ? '#dcfce7' : '#fef3c7', done ? '#166534' : '#92400e')}>
            {done ? 'Completed' : 'Pending'}
          </span>
        );
      },
      center: true,
      grow: 1,
      minWidth: '110px',
      sortable: true,
    },
    {
      name: 'Action',
      cell: (row) => renderLiveOrderActions(row),
      center: true,
      grow: 1.5,
      minWidth: '170px',
      ignoreRowClick: true,
    },
  ];

  const conditionalRowStyles = [

    {
      when: row => row.returnIdForVedor !== null,
      style: {
        backgroundColor: 'rgba(238, 145, 155, 0.1)', // Very light red
        '&:hover': {
          backgroundColor: 'rgba(238, 145, 155, 0.15)' // Slightly darker on hover
        }
      },
    },
    {
      when: row => row.exchangeIdForVedor !== null,
      style: {
        backgroundColor: 'rgba(0, 140, 255, 0.1)', // Very light blue
        '&:hover': {
          backgroundColor: 'rgba(0, 140, 255, 0.15)' // Slightly darker on hover
        }
      },
    },
    {
      when: row => row.returnIdForVedor !== null && row.exchangeIdForVedor !== null,
      style: {
        backgroundColor: 'rgba(180, 120, 255, 0.1)', // Light purple
        '&:hover': {
          backgroundColor: 'rgba(180, 120, 255, 0.15)' // Slightly darker on hover
        }
      },
    },
  ];



  const getAppliedFiltersCount = () => {
    let count = 0;

    const countArray = (arr) => (Array.isArray(arr) ? arr.length : 0);

    if (filterData.orderStatus) count += 1;
    if (filterData.paymentMode) count += 1;
    if (filterData.paymentStatus) count += 1;
    if (filterData.selected_orderType || (filterData.orderType !== null && filterData.orderType !== "")) count += 1;

    count += countArray(filterData.brands);
    count += countArray(filterData.vendors);

    if (filterData.startDate || filterData.endDate) count += 1;

    return count;
  };


  const appliedFiltersCount = getAppliedFiltersCount();





  const searchFormik = useFormik({
    initialValues: {
      startDate: filterData.startDate || '',
      endDate: filterData.endDate || '',
      orderType: filterData.orderType || '',
      selected_orderType: filterData.selected_orderType || '',
      orderStatus: filterData.orderStatus || '',
      selected_orderStatus: filterData.selected_orderStatus || '',
      paymentMode: filterData.paymentMode || '',
      selected_paymentMode: filterData.selected_paymentMode || '',
      paymentStatus: filterData.paymentStatus || '',
      selected_paymentStatus: filterData.selected_paymentStatus || '',
      brands: filterData.brands || [],
      selected_brands: filterData.selected_brands || []
    },
    validate: async (values) => {
      // Add validation logic if needed
    },
    onSubmit: (values, { resetForm }) => {
      setLoading(true);
      setFilterData(values);
      setShow(false);
    },
    enableReinitialize: true,
  });

  const exportOrdersToExcel = async (filter) => {
    setDownloadOrdersExcel(true);

    try {
      // 🔹 Build same params as fetchOrdersData
      const params = filterData ? { ...filterData, page, limit, search: filterData.search || '' } : { page, limit, search: '' };

      if (filter === "completed") {
        params.status = "CONFIRMED";
      }
      if (filter === "rejected") {
        params.status = "REJECTED";
      }
      if (filter === "cancelled") {
        params.status = "CANCELLED";
      }

      // 🔹 Call backend
      const response = await downloadOrdersExcelSheet(params);

      if (response?.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `orders_export_${new Date().toISOString().split("T")[0]}.xlsx`
        ); // dynamic file name
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.error("Error exporting orders to Excel:", error);
    } finally {
      setDownloadOrdersExcel(false);
    }
  };


  // const handleMenuScrollToBottomBrands = () => {
  //   if (!hasMoreBrands) return;
  //   const nextPage = pageBrands + 1;
  //   fetchBrands(brandSearch, nextPage).then(() => {
  //     setPageBrands(nextPage);
  //   });
  // };

  // const handleBrandInputChange = (newValue, { action }) => {
  //   if (action === 'input-change') {
  //     setPageBrands(1);
  //     setHasMoreBrands(true);
  //   }
  //   return newValue;
  // };

  const handleBulkInvoiceDownload = async () => {
    if (!bulkStartDate || !bulkEndDate) {
      toast.error("Please select date range");
      return;
    }

    if (userType == 'ADMIN' && !bulkVendors.length) {
      toast.error("Please select vendors");
      return;
    }

    try {
      setDownloadingBulkInvoice(true);

      const payload = {
        startDate: dayjs(bulkStartDate).format("YYYY-MM-DD"),
        endDate: dayjs(bulkEndDate).format("YYYY-MM-DD"),
      };

      // ✅ Only ADMIN sends vendorIds
      if (userType === 'ADMIN') {
        payload.vendorIds = bulkVendors.map(v => v.value);
      }

      const response = await downloadBulkOrderInvoice(payload);

      const blob = new Blob([response.data], { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `vendor_invoices_${payload.startDate}_${payload.endDate}.zip`
      );

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
      setBulkInvoiceModal(false);
    } catch (error) {
      console.error("Bulk invoice download failed:", error);
      toast.error("Failed to download invoices");
    } finally {
      setDownloadingBulkInvoice(false);
    }
  };


  const fetchManufacturers = (inputValue = "", currentPage = 1, limit = 100) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimer);

      typingTimer = setTimeout(() => {
        getManufacturesListingPaginate({
          page: currentPage,
          limit,
          search: inputValue
        })((response) => {
          if (response?.statusCode === 200) {
            const results = response.results.map(item => ({
              value: item.value,   // ✅ correct
              label: item.label,   // ✅ correct
            }));

            setManufacturers(results);
            setHasMoreManufacture(results.length > 0);
            resolve(results);
          } else {
            setManufacturers([]);
            setHasMoreManufacture(false);
            resolve([]);
          }
        });
      }, 300);
    });
  };



  const fetchAllOrderData = async (filter) => {
    let limit = limitDownloadOrders;
    const params = filterData ? { ...filterData, page, limit, search: filterData.search || '' } : { page, limit, search: '' };

    if (filter === 'completed') {
      params.status = 'CONFIRMED';
    }

    if (filter === 'rejected') {
      params.status = 'REJECTED';
    }

    if (filter === 'cancelled') {
      params.status = 'CANCELLED';
    }

    delete params.orderStatus;
    delete params.selected_orderStatus;
    delete params.selected_paymentMode;
    delete params.selected_paymentStatus;
    delete params.selected_orderType;

    params.orderType = params.orderType ?? "";

    getOrdersListing(params)((response) => {
      if (response?.statusCode === 200) {
        setTotalOrdersToDownload(response?.data?.orders);
        setLimitDownloadOrders(response?.data?.totalItems);
        setLoading(false);
      } else {
        setTotalOrdersToDownload([]);
        setLimitDownloadOrders(5);
        setLoading(false);
      }
    });

  }; let typingTimer;

  const fetchBrands = (inputValue, currentPage = 1, limit = 10) => {
    return new Promise((resolve) => {
      clearTimeout(typingTimer);
      console.log("Brand API params:", { page: currentPage, pageSize: limit, search: inputValue });

      typingTimer = setTimeout(() => {
        getBrandListing({ page: currentPage, pageSize: limit, search: inputValue })(response => {
          console.log("Brand API response:", response);
          if (response?.statusCode === 200) {
            const results = response?.data?.map(item => ({
              value: item.id,
              label: item.name,
            }));

            if (currentPage === 1) {
              setBrands(results);
            } else {
              setBrands((prevBrands) => [...prevBrands, ...results]);
            }

            setHasMore(results.length > 0);
            resolve(results);
          } else {
            setHasMore(false);
            resolve([]);
          }
        });
      }, 300);
    });
  };


  // const loadOptionsBrands = (inputValue) => {
  //   return fetchBrands(inputValue, 1).then((options) => {
  //     console.log("Options loaded:", options);
  //     return options;
  //   });
  // };
  // const handleMenuScrollToBottom = () => {
  //   if (hasMore) {
  //     const nextPage = pageBrands + 1;   // ✅ use pageBrands, not pagebrands
  //     fetchBrands(searchFormik.values.selected_brands?.label || '', nextPage).then(() => {
  //       setPageBrands(nextPage);
  //     });
  //   }
  // };

  const fetchOrdersData = async (filter) => {


    const params = filterData
      ? {
        ...filterData,
        orderType: filterData.orderType,
        page,
        limit,
        search: filterData.search || ''
      }
      : {
        orderType: "",
        page,
        limit,
        search: ''
      };

    if (filter === 'completed') {
      params.status = 'CONFIRMED';
    }

    if (filter === 'rejected') {
      params.status = 'REJECTED';
    }

    if (filter === 'cancelled') {
      params.status = 'CANCELLED';
    }

    if (!params.status && params.orderStatus) {
      params.status = params.orderStatus;
    }


    delete params.orderStatus;
    delete params.selected_orderStatus;
    delete params.selected_paymentMode;
    delete params.selected_paymentStatus;
    delete params.selected_orderType;
    delete params.selected_brands;

    if (params.brands && params.brands.length > 0) {
      params.brandIds = params.brands;                 // array version
      params.brand_id = params.brands[0];              // single ID (just in case)
      params.brandsCSV = params.brands.join(",");      // CSV string version
    }

    console.log('Final API params:', params);

    getOrdersListing(params)((response) => {
      if (response?.statusCode === 200) {
        setOrders(response?.data?.orders);
        setTotalRows(response?.data?.totalItems);
        setLoading(false);
      } else {
        setOrders([]);
        setLoading(false);
      }
    });
  };


  const handlePerRowsChange = (newPerPage) => {
    setPagination(prev => ({
      ...prev,
      limit: newPerPage,
      page: 1
    }));
  };

  const handlePageChange = (page) => {
    setPagination(prev => ({
      ...prev,
      page
    }));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  // const handleConfirm = (deletingId) => {
  //   setModal(!modal);
  //   setDeletingId(deletingId);
  // };

  const deleteOrder = (id) => {
    deleteOrderItem(id)((response) => {
      if (response?.request?.status == 200) {

        setModal(!modal);
      } else {
      }
    });
    // });
  };



  const applyFilters = (partial) => {
    const processed = {};

    Object.keys(partial).forEach(key => {
      if (Array.isArray(partial[key])) {
        processed[key] = partial[key].map(item =>
          typeof item === 'object' ? item.value : item
        );
      } else {
        processed[key] = partial[key];
      }
    });

    setFilterData(prev => ({
      ...prev,
      ...processed
    }));

    setPagination(prev => ({
      ...prev,
      page: 1
    }));
  };


  const onOrderTypeChange = (selectedOption) => {
    applyFilters({
      orderType: selectedOption ? selectedOption.value : "",
      selected_orderType: selectedOption || ""
    });
  }

  // FIXED: Corrected the typo here
  const onOrderStatusChange = (selectedOption) => {
    setFilter("all");
    applyFilters({
      orderStatus: selectedOption?.value || "",
      selected_orderStatus: selectedOption || ""
    });
  }

  const onpaymentModeChange = (selectedOption) => {
    applyFilters({
      paymentMode: selectedOption?.value || "",
      selected_paymentMode: selectedOption || ""
    });
  }

  const onpaymentStatusChange = (selectedOption) => {
    applyFilters({
      paymentStatus: selectedOption?.value || "",
      selected_paymentStatus: selectedOption || ""
    });
  }

  const onBrandChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    applyFilters({
      brands: selectedValues,
      selected_brands: selectedOptions || [],
    });
  }

  const handleReset = () => {
    searchFormik.resetForm({
      values: {
        startDate: "",
        endDate: '',
        orderType: "",
        selected_orderType: "",
        orderStatus: "",
        selected_orderStatus: "",
        paymentMode: "",
        selected_paymentMode: "",
        paymentStatus: "",
        selected_paymentStatus: "",
        brands: [],
        selected_brands: []
      }
    });
    setFilterData({
      search: "",
      startDate: "",
      endDate: '',
      orderType: "",
      selected_orderType: "",
      orderStatus: "",
      selected_orderStatus: "",
      paymentMode: "",
      selected_paymentMode: "",
      paymentStatus: "",
      selected_paymentStatus: "",
      brands: [],
      selected_brands: []
    });
    setShow(false);

  };


  const handleFilterSubmit = (e) => {
    e.preventDefault();
    if (isFilterApplied) {
      searchFormik.handleSubmit(e);
    } else {
      handleReset();
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchOrdersData(filter);
    setIsInitialRender(false);
  }, [filter, filterData, pagination]);

  useEffect(() => {
    const delay = setTimeout(() => {
      setPagination(prev => ({ ...prev, page: 1 }));
    }, 400);

    return () => clearTimeout(delay);
  }, [filterData.search]);


  useEffect(() => {
    if (isInitialRender) return;
    setLoading(true);
    fetchAllOrderData(filter)
  }, [filter, filterData, pagination]);

  useEffect(() => {
    fetchManufacturers("", 1, 100);
  }, []);


  useEffect(() => {
    if (ordersTrigger) {
      fetchOrdersData(filter);
      setOrdersTrigger(false);
    }
  }, [ordersTrigger]);



  useEffect(() => {
    getBrandListing({ page: 1, pageSize: 100, search: "" })((response) => {
      if (response?.statusCode === 200) {
        setBrands(
          (response?.data || []).map((item) => ({
            value: item.id,
            label: item.name,
          }))
        );
      } else {
        setBrands([]);
      }
    });
  }, []);

  const isFilterApplied = !!(
    filterData.startDate ||
    filterData.endDate ||
    filterData.selected_orderType ||
    filterData.orderType ||
    filterData.orderStatus ||
    filterData.paymentMode ||
    filterData.paymentStatus ||
    (filterData.brands && filterData.brands.length > 0)
  );

  const userType = JSON.parse(localStorage.getItem('user'))?.userType;

  const clearAllFilters = () => {
    setFilterData({
      search: "",
      startDate: "",
      endDate: "",
      orderType: "",
      selected_orderType: "",
      orderStatus: "",
      selected_orderStatus: "",
      paymentMode: "",
      selected_paymentMode: "",
      paymentStatus: "",
      selected_paymentStatus: "",
      brands: [],
      selected_brands: [],
      vendors: [],
    });
    setPagination(prev => ({ ...prev, page: 1 }));
  };

  const orderStatusChip = (status) => {
    if (!status) return null;
    // Match the desktop table Status column exactly
    let bg = '#334155', color = '#fff';
    switch (status) {
      case 'CANCELLED': bg = '#dc2626'; color = '#fff'; break;
      case 'INITIATED': bg = '#facc15'; color = '#0f172a'; break;
      case 'CONFIRMED': bg = '#0e7490'; color = '#fff'; break;
      case 'DELIVERED': bg = '#10b981'; color = '#fff'; break;
      case 'REJECTED': bg = '#dc2626'; color = '#fff'; break;
      default: bg = '#6d28d9'; color = '#fff';
    }
    return { bg, color, label: status.toLowerCase().split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') };
  };

  return (
    <div className="orders-page">
      <style>{`
        /* Attention icon for INITIATED orders — mirrors the Live Orders table on Dashboard */
        @keyframes ordersActionShake {
          0%, 60%, 100% { transform: rotate(0deg); }
          5%  { transform: rotate(-14deg); }
          10% { transform: rotate(12deg); }
          15% { transform: rotate(-10deg); }
          20% { transform: rotate(8deg); }
          25% { transform: rotate(-5deg); }
          30% { transform: rotate(3deg); }
          35% { transform: rotate(0deg); }
        }
        .orders-page .action-required-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: #dc2626;
          color: #fff;
          border-radius: 50%;
          border: 1.5px solid #fff;
          transform-origin: center;
          animation: ordersActionShake 1.6s ease-in-out infinite;
          box-shadow: 0 1px 3px rgba(220,38,38,0.35);
        }
        @media (prefers-reduced-motion: reduce) {
          .orders-page .action-required-icon { animation: none; }
        }

        .orders-page h3 { font-size: 18px !important; }
        .orders-page h4 { font-size: 16px !important; }
        .orders-page h5 { font-size: 14px !important; }
        .orders-page h6 { font-size: 12px !important; }
        .orders-page p { font-size: 12px; }
        .orders-page .small, .orders-page small { font-size: 11px !important; }
        .orders-page .badge { font-size: 10px !important; padding: 3px 7px !important; }
        .orders-page .btn { font-size: 12px; }

        /* Compact action buttons */
        .orders-page .ord-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          padding: 6px 18px !important;
          border-radius: 4px !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          height: 34px;
          white-space: nowrap;
          transition: all 0.15s ease;
          border: 1px solid #e2e8f0;
          background: #fff;
          color: #475569;
          cursor: pointer;
          position: relative;
        }
        .orders-page .ord-btn:hover {
          border-color: #008695;
          color: #008695;
          background: rgba(0,134,149,0.06);
        }
        .orders-page .ord-btn-primary {
          background: #008695 !important;
          border-color: #008695 !important;
          color: #fff !important;
        }
        .orders-page .ord-btn-primary:hover {
          background: #006672 !important;
          border-color: #006672 !important;
          color: #fff !important;
        }
        .orders-page .ord-btn svg { width: 14px; height: 14px; }

        /* Search input */
        .orders-page .ord-search-input {
          border: 1px solid #e2e8f0 !important;
          border-radius: 4px !important;
          padding: 6px 12px !important;
          font-size: 12px !important;
          height: 34px !important;
          background: #fff !important;
          color: #0f172a !important;
        }
        .orders-page .ord-search-input:focus {
          border-color: #008695 !important;
          box-shadow: 0 0 0 3px rgba(0,134,149,0.15) !important;
          outline: none;
        }

        /* Filter count badge */
        .orders-page .ord-filter-count {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 16px;
          height: 16px;
          padding: 0 4px;
          font-size: 10px;
          font-weight: 700;
          color: #fff;
          background: #008695;
          border-radius: 999px;
          margin-left: 2px;
        }

        /* DataTable container */
        .orders-page .products-and-options .MuiPaper-root {
          border: 1px solid #e2e8f0 !important;
          border-radius: 10px !important;
          overflow: hidden;
          box-shadow: none !important;
        }

        /* Match homepage: soft neutral background + consistent 16px horizontal gutter */
        .orders-page { background: #f9fafb; min-height: calc(100vh - 70px); }
        .main-content:has(.orders-page) { background: #f9fafb; }
        .page-content:has(.orders-page) { background: #f9fafb; }
        body:has(.orders-page) .page-content,
        body:has(.orders-page) #layout-wrapper.no-topbar .page-content,
        body:has(.orders-page) #layout-wrapper .page-content {
          padding-top: 0 !important;
          padding-left: 16px !important;
          padding-right: 16px !important;
        }
        body:has(.orders-page) .container-fluid,
        body:has(.orders-page) .container {
          padding-left: 0 !important;
          padding-right: 0 !important;
        }

        /* Sticky header — bleeds edge-to-edge; horizontal padding matches .modern-panel-header */
        .orders-page .page-header-sticky {
          padding: clamp(14px, 1.6vw, 24px) clamp(14px, 1.4vw, 20px) clamp(10px, 1.2vw, 18px) !important;
          margin: 0 -16px 16px !important;
          top: 0 !important;
          background: #f9fafb !important;
          border-bottom: 1px solid #eef2f7 !important;
          box-shadow: none !important;
        }
        .orders-page .page-header-sticky > .d-flex { margin-bottom: 0 !important; }
        @media (max-width: 991px) {
          .orders-page .page-header-sticky {
            padding: 16px 16px 12px !important;
          }
        }
        @media (max-width: 767.98px) {
          .orders-page .page-header-sticky {
            padding: 10px 16px 8px !important;
            margin: 0 -16px 8px !important;
            position: static !important;
          }
        }
        @media (max-width: 480px) {
          .orders-page .page-header-sticky {
            padding: 10px 16px 8px !important;
            margin: 0 -16px 8px !important;
          }
        }

        .orders-page .ord-search-row { margin: 12px 0 !important; padding: 0; }
        @media (max-width: 767.98px) {
          .orders-page .ord-search-row { margin: 0 0 8px !important; }
        }
        .orders-page .products-and-options { padding: 0; }

        /* Mobile card grid — hidden on desktop */
        .orders-page .orders-mobile-list { display: none; }
        .orders-page .orders-mobile-pagination { display: none; }

        /* Responsive */
        @media (max-width: 767.98px) {
          .orders-page .page-header-sticky > .d-flex {
            flex-wrap: nowrap !important;
            gap: 6px !important;
          }
          .orders-page .page-header-sticky > .d-flex > h3 {
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .orders-page .ord-header-actions {
            gap: 6px !important;
            flex-wrap: nowrap !important;
            flex-shrink: 0;
          }
          .orders-page .ord-header-actions .ord-btn {
            width: 32px;
            height: 32px;
            padding: 0 !important;
          }
          .orders-page .ord-header-actions .ord-btn-label { display: none; }

          .orders-page .ord-search-row { flex-wrap: nowrap !important; gap: 8px !important; }
          .orders-page .ord-search-row > div:first-child { flex: 1 1 auto !important; min-width: 0 !important; }
          .orders-page .ord-filter-actions { flex-shrink: 0; gap: 6px !important; }
          .orders-page .ord-filter-btn,
          .orders-page .ord-clear-btn {
            width: 34px;
            padding: 0 !important;
          }
          .orders-page .ord-filter-btn .ord-btn-label,
          .orders-page .ord-clear-btn .ord-btn-label { display: none; }
          .orders-page .ord-filter-btn .ord-filter-count {
            position: absolute;
            top: -4px; right: -4px;
            min-width: 14px; height: 14px;
            padding: 0 3px;
            font-size: 9px;
            margin-left: 0;
          }

          /* Swap table for mobile card list */
          .orders-page .products-and-options { display: none !important; }
          .orders-page .orders-mobile-list {
            display: flex;
            flex-direction: column;
            gap: 10px;
            padding: 8px 0 calc(56px + env(safe-area-inset-bottom, 0px));
          }

          /* Fixed bottom pagination bar */
          .orders-page .orders-mobile-pagination {
            display: flex !important;
            position: fixed;
            left: 0; right: 0; bottom: 0;
            padding: 8px 12px calc(8px + env(safe-area-inset-bottom, 0px));
            background: #fff;
            border-top: 1px solid #e2e8f0;
            box-shadow: 0 -2px 8px rgba(15,23,42,0.05);
            z-index: 1049;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
          }
          .orders-page .omp-btn {
            width: 40px; height: 36px;
            border-radius: 6px;
            border: 1px solid #e2e8f0;
            background: #fff;
            color: #0f172a;
            font-size: 16px;
            font-weight: 700;
            cursor: pointer;
            display: inline-flex; align-items: center; justify-content: center;
            transition: all 0.15s ease;
          }
          .orders-page .omp-btn:hover:not(:disabled) {
            border-color: #008695;
            color: #008695;
            background: rgba(0,134,149,0.06);
          }
          .orders-page .omp-btn:disabled {
            opacity: 0.35;
            cursor: not-allowed;
          }
          .orders-page .omp-info {
            font-size: 11px;
            color: #475569;
            display: inline-flex;
            align-items: baseline;
            gap: 4px;
            flex: 1;
            justify-content: center;
            text-align: center;
          }
          .orders-page .omp-info strong { color: #008695; font-weight: 700; }
          .orders-page .omp-total { color: #94a3b8; font-size: 10px; }
        }

        /* Mobile order card */
        .orders-page .order-card {
          background: #fff;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          padding: 12px;
          cursor: pointer;
          transition: transform 0.12s ease, border-color 0.15s ease;
        }
        .orders-page .order-card:active { transform: scale(0.99); border-color: #008695; }
        .orders-page .order-card-top {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 8px;
          margin-bottom: 8px;
        }
        .orders-page .order-card-id {
          font-size: 10px;
          font-weight: 700;
          color: #0f172a;
        }
        .orders-page .order-card-date {
          font-size: 9px;
          color: #64748b;
          margin-top: 1px;
        }
        .orders-page .order-card-chip {
          font-size: 10px !important;
          font-weight: 600;
          padding: 3px 8px !important;
          border-radius: 4px;
          white-space: nowrap;
          letter-spacing: 0.01em;
        }
        .orders-page .order-card-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 6px;
          font-size: 10px;
        }
        .orders-page .order-card-row + .order-card-row { margin-top: 4px; }
        .orders-page .order-card-label { color: #64748b; font-size: 10px; }
        .orders-page .order-card-value { color: #0f172a; font-weight: 600; font-size: 10px; }
        .orders-page .order-card-amount { color: #008695; font-weight: 700; font-size: 11px; }
        .orders-page .order-card-price {
          color: #008695;
          font-weight: 800;
          font-size: 15px;
          letter-spacing: -0.02em;
          line-height: 1.1;
          margin: 2px 0 4px;
        }
        .orders-page .order-card-pay {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          padding: 2px;
          border-radius: 999px;
          background: #f8fafc;
          border: 1px solid #eef2f7;
          width: fit-content;
        }
        .orders-page .order-card-pay-mode,
        .orders-page .order-card-pay-status {
          font-size: 9px;
          font-weight: 700;
          padding: 3px 8px;
          border-radius: 999px;
          white-space: nowrap;
          letter-spacing: 0.02em;
          text-transform: uppercase;
        }
        .orders-page .order-card-pay-status {
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }
        .orders-page .order-card-pay-dot {
          width: 5px; height: 5px;
          border-radius: 50%;
          display: inline-block;
          box-shadow: 0 0 0 2px rgba(255,255,255,0.5);
        }
        .orders-page .order-card-type {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 9px;
          color: #475569;
        }
        .orders-page .order-card-type img { width: 10px; height: 10px; object-fit: contain; }

        /* Empty state (desktop table + mobile list) */
        .orders-empty {
          width: 100%;
          min-height: 340px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 32px 20px;
          text-align: center;
          color: #64748b;
          background: linear-gradient(180deg, #fafbfd 0%, #f5f7fa 100%);
        }
        .orders-empty-icon {
          font-size: 40px;
          margin-bottom: 12px;
          opacity: 0.7;
          filter: grayscale(0.2);
        }
        .orders-empty-title {
          font-size: 15px;
          font-weight: 700;
          color: #0f172a;
          letter-spacing: -0.01em;
          margin-bottom: 4px;
        }
        .orders-empty-sub {
          font-size: 12px;
          color: #94a3b8;
          font-weight: 500;
        }
        @media (max-width: 767.98px) {
          .orders-mobile-list .orders-empty {
            min-height: 260px;
            padding: 28px 16px;
            border: 1px solid #eef2f7;
            border-radius: 12px;
            margin: 8px 0;
          }
          .orders-mobile-list .orders-empty-icon { font-size: 34px; margin-bottom: 8px; }
          .orders-mobile-list .orders-empty-title { font-size: 13px; }
          .orders-mobile-list .orders-empty-sub { font-size: 11px; }
        }
      `}</style>

      <div className="page-header-sticky">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
          <div className="d-flex align-items-center">
            <h3 className="mb-0 fw-bolder">Orders</h3>
          </div>

          <div className="d-flex align-items-center gap-2 flex-wrap ord-header-actions">
            <div className="ord-btn" onClick={() => setBulkInvoiceModal(true)}>
              <FiFile />
              <span className="ord-btn-label">Download Bulk Invoice</span>
            </div>

            {userType !== 'customerSupport' && (
              <div className="ord-btn ord-btn-primary" onClick={() => exportOrdersToExcel()}>
                {downloadOrdersExcel ? (
                  <>
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    <span className="ord-btn-label">Exporting...</span>
                  </>
                ) : (
                  <>
                    <FiDownload />
                    <span className="ord-btn-label">Export orders</span>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="ord-search-row d-flex justify-content-between align-items-center gap-2 flex-wrap">
        <div style={{ flex: 2, minWidth: '220px' }}>
          <Form.Control
            type="text"
            placeholder="Search for orders..."
            className="ord-search-input"
            value={filterData.search || ""}
            onChange={(e) => setFilterData(prev => ({ ...prev, search: e.target.value }))}
          />
        </div>

        <div className="d-flex align-items-center gap-2 ord-filter-actions">
          <button
            type="button"
            className="ord-btn ord-filter-btn"
            onClick={() => setShowFilterModal(true)}
          >
            <FiFilter />
            <span className="ord-btn-label">Filters</span>
            {appliedFiltersCount > 0 && (
              <span className="ord-filter-count">{appliedFiltersCount}</span>
            )}
          </button>

          <button
            type="button"
            className="ord-btn ord-clear-btn"
            onClick={clearAllFilters}
          >
            <FiX />
            <span className="ord-btn-label">Clear</span>
          </button>
        </div>
      </div>

      <div className="col-12">
        <Box className="products-and-options">
          <Paper square className="shadow-none border border-blue-grey-200">
            <DataTable
              columns={columns}
              conditionalRowStyles={conditionalRowStyles}
              data={orders}
              progressPending={loading}
              progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationPerPage={limit}
              onRowClicked={(row) => navigate('/orderdetails/' + row?.id)}
              onChangeRowsPerPage={handlePerRowsChange}
              pointerOnHover
              highlightOnHover
              paginationRowsPerPageOptions={[10, 50, 100, 150]}
              onChangePage={handlePageChange}
              currentPage={page}
              customStyles={queueDatatableCustomStyles}
              noDataComponent={
                <div className="orders-empty">
                  <div className="orders-empty-icon" aria-hidden="true">📦</div>
                  <div className="orders-empty-title">No orders found</div>
                  <div className="orders-empty-sub">Try adjusting the filters or come back later.</div>
                </div>
              }
            />
          </Paper>
        </Box>

        <div className="orders-mobile-list">
          {loading ? (
            <div style={{ height: '40vh' }}><Loader /></div>
          ) : orders && orders.length > 0 ? (
            orders.map((row) => {
              const chip = orderStatusChip(row?.status);
              const t = row?.orderType;
              const sfe = row?.statusForExchangeOrder;
              const typeLabel = t === 3
                ? 'Delivered'
                : t === 2
                  ? (sfe === 1 ? 'EXCHANGE_RETURN' : sfe === 2 ? 'EXCHANGE_DELIVERY' : 'Exchange')
                  : t === 1
                    ? 'Return'
                    : 'New';
              let typeBg = '#e0f2fe', typeColor = '#0369a1';
              if (t === 1) { typeBg = '#fee2e2'; typeColor = '#b91c1c'; }
              else if (t === 2) {
                if (sfe === 1) { typeBg = '#fef3c7'; typeColor = '#92400e'; }
                else if (sfe === 2) { typeBg = '#dbeafe'; typeColor = '#1d4ed8'; }
                else { typeBg = '#ede9fe'; typeColor = '#6d28d9'; }
              }
              else if (t === 3) { typeBg = '#dcfce7'; typeColor = '#166534'; }
              const amt = userType === 'ADMIN' ? row?.amount : row?.billingAmount;
              const done = row?.paymentStatus === 'DONE';
              const products = row?.orderProducts || [];
              const firstImg = products.find(p => p?.Product?.thumbnailImageUrl)?.Product?.thumbnailImageUrl;
              const extra = products.length > 1 ? products.length - 1 : 0;
              const needsAction = row?.status === 'INITIATED';
              return (
                <div
                  key={row.id}
                  className="order-card"
                  onClick={() => navigate('/orderdetails/' + row?.id)}
                >
                  <div style={{ display: 'flex', gap: 12, alignItems: 'stretch', width: '100%' }}>
                  {/* Image on the left */}
                  <div style={{ position: 'relative', flexShrink: 0 }}>
                    {/* Type label overlay on top of the image */}
                    <span
                      style={{
                        position: 'absolute',
                        top: 6,
                        left: 6,
                        zIndex: 2,
                        display: 'inline-block',
                        backgroundColor: typeBg,
                        color: typeColor,
                        padding: '2px 6px',
                        borderRadius: '999px',
                        fontSize: '8px',
                        fontWeight: 700,
                        lineHeight: 1.2,
                        boxShadow: '0 1px 3px rgba(15,23,42,0.15)',
                      }}
                    >
                      {typeLabel}
                    </span>
                    {firstImg ? (
                      <img
                        src={firstImg}
                        alt="product"
                        style={{
                          width: 96,
                          height: 100,
                          borderRadius: 6,
                          objectFit: 'cover',
                          border: '1px solid #e2e8f0',
                          display: 'block',
                        }}
                        onError={(e) => { e.currentTarget.style.display = 'none'; }}
                      />
                    ) : (
                      <div
                        style={{
                          width: 96,
                          height: 100,
                          borderRadius: 6,
                          background: '#f1f5f9',
                          border: '1px solid #e2e8f0',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#94a3b8',
                          fontSize: 9,
                          fontWeight: 600,
                        }}
                      >
                        N/A
                      </div>
                    )}
                    {extra > 0 && (
                      <span
                        style={{
                          position: 'absolute',
                          top: needsAction ? undefined : -4,
                          bottom: needsAction ? -4 : undefined,
                          right: -6,
                          minWidth: 18,
                          height: 18,
                          padding: '0 5px',
                          background: '#0f172a',
                          color: '#fff',
                          fontSize: 10,
                          fontWeight: 700,
                          borderRadius: 999,
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          lineHeight: 1,
                        }}
                      >
                        +{extra}
                      </span>
                    )}
                    {needsAction && (
                      <span
                        className="action-required-icon"
                        style={{ position: 'absolute', top: -6, right: -6, width: 22, height: 22, zIndex: 3 }}
                        aria-label="Action required"
                        title="Action required"
                      >
                        <FiAlertTriangle size={13} strokeWidth={2.8} />
                      </span>
                    )}
                  </div>

                  {/* All labels / status stacked on the right */}
                  <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 6 }}>
                    {/* Top row: Order Id + Status chip */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                      <div style={{ minWidth: 0, flex: 1 }}>
                        <div className="order-card-id">#{row?.orderId}</div>
                        <div className="order-card-date">
                          {moment(row?.createdAt).format('DD MMM YY, hh:mm a')}
                        </div>
                      </div>
                      {chip && (
                        <span className="order-card-chip" style={{ background: chip.bg, color: chip.color, flexShrink: 0 }}>
                          {chip.label}
                        </span>
                      )}
                    </div>

                    {/* Price — prominent, right under the id+date row */}
                    <div className="order-card-price">₹{amt}</div>

                    {/* Payment method + status — split pill */}
                    {(() => {
                      const mode = (row?.paymentMode || '').toUpperCase();
                      const isCOD = mode === 'COD';
                      const modeLabel = isCOD ? 'COD' : mode ? 'Online' : '—';
                      // Method: neutral slate for both — text-only differentiation
                      const modeBg = '#f1f5f9';
                      const modeColor = '#475569';
                      // Status: standard muted green (Paid) / amber (Pending)
                      const statusBg = done ? '#f0fdf4' : '#fffbeb';
                      const statusColor = done ? '#15803d' : '#b45309';
                      const statusDot = done ? '#16a34a' : '#d97706';
                      const statusLabel = done ? 'Paid' : 'Pending';
                      return (
                        <div className="order-card-pay">
                          <span
                            className="order-card-pay-mode"
                            style={{ background: modeBg, color: modeColor }}
                          >
                            {modeLabel}
                          </span>
                          <span
                            className="order-card-pay-status"
                            style={{ background: statusBg, color: statusColor }}
                          >
                            <span className="order-card-pay-dot" style={{ background: statusDot }} />
                            {statusLabel}
                          </span>
                        </div>
                      );
                    })()}
                  </div>
                  </div>
                  {/* Action buttons / OTP row — full-width, sibling to the image+details row */}
                  {(() => {
                    const actions = renderLiveOrderActions(row, true);
                    if (!actions) return null;
                    return (
                      <div style={{ width: '100%', marginTop: 10, paddingTop: 10, borderTop: '1px solid #e2e8f0' }}>
                        {actions}
                      </div>
                    );
                  })()}
                </div>
              );
            })
          ) : (
            <div className="orders-empty">
              <div className="orders-empty-icon" aria-hidden="true">📦</div>
              <div className="orders-empty-title">No orders found</div>
              <div className="orders-empty-sub">Try adjusting the filters or come back later.</div>
            </div>
          )}
        </div>
      </div>

      {/* Mobile-only fixed pagination bar */}
      {(() => {
        const totalPages = Math.max(1, Math.ceil((totalRows || 0) / (limit || 1)));
        const canPrev = page > 1;
        const canNext = page < totalPages;
        return (
          <div className="orders-mobile-pagination">
            <button
              type="button"
              className="omp-btn"
              onClick={() => canPrev && handlePageChange(page - 1)}
              disabled={!canPrev}
              aria-label="Previous page"
            >
              ←
            </button>
            <span className="omp-info">
              Page <strong>{page}</strong> of <strong>{totalPages}</strong>
              <span className="omp-total">· {totalRows || 0} orders</span>
            </span>
            <button
              type="button"
              className="omp-btn"
              onClick={() => canNext && handlePageChange(page + 1)}
              disabled={!canNext}
              aria-label="Next page"
            >
              →
            </button>
          </div>
        );
      })()}
      <CustomisedModal
        isOpen={modal}
        customClass={"policy_modal"}
        toggle={toggleModal}
      >
        <h5>Are you sure you want to remove this item?</h5>
        <div className="policy_Agree">
          <Button
            onClick={() => {
              setModal(!modal);
            }}
            size="lg"
            className="btn_cancel"
          >
            Cancel
          </Button>
          <Button
            size="lg"
            className="btn"
            onClick={() => deleteOrder(deletingId)}
          >
            Delete
          </Button>
        </div>
      </CustomisedModal>

      <BulkInvoiceModal
        open={bulkInvoiceModal}
        onClose={() => setBulkInvoiceModal(false)}
        vendors={manufacturers}          // vendor list
        selectedVendors={bulkVendors}
        setSelectedVendors={setBulkVendors}
        startDate={bulkStartDate}
        setStartDate={setBulkStartDate}
        endDate={bulkEndDate}
        setEndDate={setBulkEndDate}
        loading={downloadingBulkInvoice}
        onDownload={handleBulkInvoiceDownload}
      />

      <OrderFilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        onApplyFilters={applyFilters}
        searchFormik={searchFormik}
        filterData={filterData}
        userType={userType}
      />

      {/* Reject Confirmation Modal */}
      <Modal
        show={showRejectConfirm}
        onHide={() => !orderActionLoadingId && setShowRejectConfirm(false)}
        centered
        backdrop={orderActionLoadingId ? 'static' : true}
        keyboard={!orderActionLoadingId}
        dialogClassName={(pendingRejectOrder?.orderType === 1 || pendingRejectOrder?.orderType === 2) ? 'orders-reject-modal-wide' : ''}
      >
        <style>{`.orders-reject-modal-wide { max-width: 460px; }`}</style>
        <Modal.Header closeButton={!orderActionLoadingId} style={{ padding: '14px 20px', borderBottom: '1px solid #e5e7eb' }}>
          <Modal.Title as="span" style={{ fontSize: 14, fontWeight: 700, color: '#0f172a' }}>
            Reject {pendingRejectOrder?.orderType === 2 ? 'exchange ' : pendingRejectOrder?.orderType === 1 ? 'return ' : ''}order?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '16px 20px', fontSize: 12, color: '#475569' }}>
          Order <strong style={{ color: '#0f172a' }}>{pendingRejectOrder?.orderId}</strong> will be marked as rejected. This action cannot be undone.
          {(pendingRejectOrder?.orderType === 1 || pendingRejectOrder?.orderType === 2) && (
            <div style={{ marginTop: 16, borderTop: '1px solid #e5e7eb', paddingTop: 14 }}>
              <label style={{ display: 'block', marginBottom: 5, fontSize: 11, fontWeight: 600, color: '#475569', letterSpacing: '0.02em' }}>
                Rejection reason
              </label>
              <Form.Select
                value={rejectionReason}
                onChange={(e) => setRejectionReason(e.target.value)}
                disabled={Boolean(orderActionLoadingId)}
                style={{ fontSize: 12, padding: '7px 10px', borderRadius: 6, border: '1px solid #cbd5e1', color: '#0f172a', marginBottom: 10 }}
              >
                <option value="">Choose a rejection reason...</option>
                {EVIDENCE_REJECTION_REASONS.map((reason, idx) => (
                  <option key={idx} value={reason}>{reason}</option>
                ))}
              </Form.Select>
              <label style={{ display: 'block', marginBottom: 5, fontSize: 11, fontWeight: 600, color: '#475569', letterSpacing: '0.02em' }}>
                Any other reason
              </label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Provide specific reason for rejection (minimum 10 characters)..."
                value={customReason}
                onChange={(e) => setCustomReason(e.target.value)}
                disabled={Boolean(orderActionLoadingId)}
                style={{ fontSize: 12, padding: '8px 10px', borderRadius: 6, border: '1px solid #cbd5e1', color: '#0f172a', minHeight: 72, resize: 'vertical' }}
              />
              <div style={{ marginTop: 4, fontSize: 10, textAlign: 'right', color: customReason && customReason.trim().length >= 10 ? '#16a34a' : '#94a3b8' }}>
                {customReason?.length || 0}/10 characters
                {customReason && customReason.trim().length >= 10 && ' ✓'}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer style={{ padding: '10px 16px', borderTop: '1px solid #e5e7eb', background: '#f8fafc', gap: 8 }}>
          <button type="button" onClick={() => { setShowRejectConfirm(false); setPendingRejectOrder(null); setRejectionReason(''); setCustomReason(''); }} disabled={orderActionLoadingId}
            style={{ padding: '6px 14px', height: 34, borderRadius: 6, border: '1px solid #e2e8f0', background: '#fff', color: '#475569', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
            Cancel
          </button>
          {(() => {
            const needsReason = pendingRejectOrder?.orderType === 1 || pendingRejectOrder?.orderType === 2;
            const reasonReady = !needsReason || (rejectionReason || (customReason && customReason.trim().length >= 10));
            const disabled = Boolean(orderActionLoadingId) || !reasonReady;
            return (
              <button type="button" onClick={confirmRejectOrder} disabled={disabled}
                style={{ padding: '6px 14px', height: 34, borderRadius: 6, border: 0, background: '#dc2626', color: '#fff', fontSize: 12, fontWeight: 700, cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1, display: 'inline-flex', alignItems: 'center', gap: 6, boxShadow: '0 3px 8px rgba(220,38,38,0.22)' }}>
                {orderActionLoadingId ? (<><Spinner as="span" animation="border" size="sm" /> Rejecting...</>) : (<><FiX size={13} /> Yes, Reject</>)}
              </button>
            );
          })()}
        </Modal.Footer>
      </Modal>

      {/* Approve Confirmation Modal — reviews the products before calling approve */}
      <Modal
        show={showApproveConfirm}
        onHide={() => !orderActionLoadingId && setShowApproveConfirm(false)}
        centered
        size="md"
        backdrop={orderActionLoadingId ? 'static' : true}
        keyboard={!orderActionLoadingId}
        dialogClassName="approve-order-modal"
      >
        <style>{`
          .approve-order-modal .modal-dialog { max-width: 520px; }
          .approve-order-modal .modal-content { border: 0; border-radius: 12px; overflow: hidden; }
          .approve-order-modal .modal-header {
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            padding: 12px 20px !important;
            min-height: 52px !important;
            border-bottom: 1px solid #e5e7eb;
          }
          .approve-order-modal .modal-header .modal-title {
            margin: 0 !important;
            padding: 0 !important;
            display: inline-block !important;
            line-height: 1.2 !important;
            white-space: normal;
          }
          .approve-order-modal .modal-header .btn-close {
            margin: 0 !important;
            padding: 8px !important;
            align-self: center !important;
          }
          .approve-order-modal .modal-body { padding: 14px 20px; max-height: 60vh; overflow-y: auto; background: #f8fafc; }
          .approve-order-modal .modal-footer {
            display: flex !important;
            align-items: center !important;
            justify-content: flex-end !important;
            padding: 10px 16px !important;
            min-height: 54px !important;
            border-top: 1px solid #e5e7eb;
            background: #fff;
            gap: 8px;
          }
          .approve-order-modal .modal-footer > * { margin: 0 !important; }
          .approve-order-modal .ao-title {
            display: inline-block;
            margin: 0;
            padding: 0;
            font-size: 14px;
            font-weight: 700;
            color: #0f172a;
            letter-spacing: -0.01em;
            line-height: 1.2;
            vertical-align: middle;
          }
          .approve-order-modal .ao-product {
            display: flex;
            gap: 12px;
            padding: 10px;
            background: #fff;
            border: 1px solid #e5e7eb;
            border-radius: 10px;
            margin-bottom: 8px;
          }
          .approve-order-modal .ao-product:last-child { margin-bottom: 0; }
          .approve-order-modal .ao-product-img,
          .approve-order-modal .ao-product-img-fallback {
            width: 64px; height: 64px; flex-shrink: 0;
            border-radius: 8px; object-fit: cover;
            border: 1px solid #e2e8f0; background: #f1f5f9;
          }
          .approve-order-modal .ao-product-img-fallback {
            display: inline-flex; align-items: center; justify-content: center;
            color: #94a3b8; font-size: 10px; font-weight: 600;
          }
          .approve-order-modal .ao-product-body { flex: 1; min-width: 0; display: flex; flex-direction: column; }
          .approve-order-modal .ao-product-name {
            margin: 0;
            font-size: 12.5px;
            font-weight: 700;
            color: #0f172a;
            letter-spacing: -0.01em;
            line-height: 1.3;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .approve-order-modal .ao-product-store {
            display: block;
            margin-top: 2px;
            margin-bottom: 8px;
            font-size: 10px;
            font-weight: 600;
            color: #64748b;
            line-height: 1.2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .approve-order-modal .ao-product-meta {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 4px 6px;
            font-size: 10px;
            color: #475569;
          }
          .approve-order-modal .ao-name-store-gap { height: 8px; }
          .approve-order-modal .ao-chip {
            display: inline-flex;
            align-items: center;
            gap: 3px;
            padding: 2px 7px;
            border-radius: 999px;
            background: #f1f5f9;
            font-weight: 600;
            white-space: nowrap;
          }
          .approve-order-modal .ao-chip-size {
            background: #e0f2fe;
            color: #0369a1;
            font-size: 12px !important;
            font-weight: 800 !important;
            padding: 4px 10px !important;
            letter-spacing: 0.03em;
            border: 1.5px solid #7dd3fc;
            box-shadow: 0 1px 2px rgba(3, 105, 161, 0.12);
            text-transform: uppercase;
          }
          .approve-order-modal .ao-color-chip {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 2px 8px 2px 4px;
            border-radius: 999px;
            background: #f8fafc;
            border: 1px solid #e2e8f0;
            font-weight: 600;
            color: #334155;
            white-space: nowrap;
          }
          .approve-order-modal .ao-color-swatch {
            width: 14px;
            height: 14px;
            border-radius: 50%;
            border: 1px solid rgba(15, 23, 42, 0.15);
            box-shadow: inset 0 0 0 1px rgba(255,255,255,0.4);
            flex-shrink: 0;
          }
          .approve-order-modal .ao-product-price {
            margin-left: auto;
            padding-left: 8px;
            font-size: 12.5px;
            font-weight: 800;
            color: #0f172a;
            font-variant-numeric: tabular-nums;
            flex-shrink: 0;
          }
          .approve-order-modal .ao-total-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 12px;
            margin-top: 8px;
            background: #ecfdf5;
            border: 1px solid #bbf7d0;
            border-radius: 10px;
            font-size: 12px;
            font-weight: 700;
            color: #166534;
          }
          .approve-order-modal .ao-total-row .ao-total-value {
            font-size: 14px;
            font-variant-numeric: tabular-nums;
          }
        `}</style>
        <Modal.Header closeButton={!orderActionLoadingId}>
          <Modal.Title as="span" className="ao-title">
            {(() => {
              const t = pendingApproveOrder?.orderType;
              const sfe = pendingApproveOrder?.statusForExchangeOrder;
              let kindLabel = 'new';
              let kindColor = '#0369a1';
              if (t === 2) {
                if (sfe === 1) { kindLabel = 'exchange return'; kindColor = '#b45309'; }
                else if (sfe === 2) { kindLabel = 'exchange delivery'; kindColor = '#1d4ed8'; }
                else { kindLabel = 'exchange'; kindColor = '#6d28d9'; }
              } else if (t === 1) {
                kindLabel = 'return'; kindColor = '#b91c1c';
              } else {
                kindLabel = 'new'; kindColor = '#0369a1';
              }
              return (
                <>
                  Approve{' '}
                  <span style={{ color: kindColor, fontWeight: 800, textTransform: 'capitalize' }}>{kindLabel}</span>
                  {' '}order {pendingApproveOrder?.orderId}?
                </>
              );
            })()}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(pendingApproveOrder?.orderProducts || []).length === 0 ? (
            <div style={{ padding: 24, textAlign: 'center', color: '#94a3b8', fontSize: 12 }}>No products in this order.</div>
          ) : (
            (pendingApproveOrder?.orderProducts || []).map((item, i) => {
              const p = item?.Product || {};
              const img = p?.thumbnailImageUrl || p?.images?.[0]?.image_url || '';
              const size = item?.VariationSize?.size || item?.productParameter?.size || p?.size || null;
              const price = item?.pricePaidByCustomer ?? item?.price ?? 0;
              return (
                <div key={item?.id || i} className="ao-product">
                  {img ? (
                    <img src={img} alt={p?.productName || 'product'} className="ao-product-img"
                      onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                  ) : (
                    <span className="ao-product-img-fallback">N/A</span>
                  )}
                  <div className="ao-product-body">
                    <h6 className="ao-product-name">{p?.productName || 'Unnamed product'}</h6>
                    {userType === 'ADMIN' && p?.manufacturer?.storeName ? (
                      <span className="ao-product-store" title={p.manufacturer.storeName}>
                        {p.manufacturer.storeName}
                      </span>
                    ) : (
                      <span className="ao-name-store-gap" aria-hidden="true" />
                    )}
                    <div className="ao-product-meta">
                      {p?.color && (
                        <span className="ao-color-chip" title={p.color}>
                          <span className="ao-color-swatch" style={{ background: p.color }} />
                          {p.color}
                        </span>
                      )}
                      {(size || item?.quantity != null) && (
                        <span className="ao-chip ao-chip-size">
                          {size || 'N/A'} × {item?.quantity ?? 1}
                        </span>
                      )}
                      <span className="ao-product-price">₹{formatINR(price)}</span>
                    </div>
                  </div>
                </div>
              );
            })
          )}
          {(() => {
            const orderTotal = userType === 'ADMIN' ? pendingApproveOrder?.amount : pendingApproveOrder?.billingAmount;
            if (orderTotal == null) return null;
            return (
              <div className="ao-total-row">
                <span>Order total</span>
                <span className="ao-total-value">₹{formatINR(orderTotal)}</span>
              </div>
            );
          })()}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" onClick={confirmApproveOrder} disabled={orderActionLoadingId}
            style={{ padding: '6px 16px', height: 34, borderRadius: 6, border: 0, background: '#008695', color: '#fff', fontSize: 12, fontWeight: 700, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6, boxShadow: '0 3px 8px rgba(0, 134, 149, 0.22)' }}>
            {orderActionLoadingId ? (<><Spinner as="span" animation="border" size="sm" /> Approving...</>) : (<>Confirm &amp; Approve</>)}
          </button>
        </Modal.Footer>
      </Modal>

      {/* Video Preview Modal — evidence-only view for exchange orders */}
      <Modal
        show={showVideoPreview}
        onHide={closeVideoPreview}
        centered
        size="md"
        dialogClassName="video-preview-modal"
      >
        <style>{`
          .video-preview-modal .modal-dialog { max-width: 560px; }
          .video-preview-modal .modal-content { border: 0; border-radius: 12px; overflow: hidden; }
          .video-preview-modal .modal-header {
            display: flex !important;
            align-items: center !important;
            padding: 12px 20px !important;
            min-height: 52px !important;
            border-bottom: 1px solid #e5e7eb;
          }
          .video-preview-modal .modal-header .modal-title { margin: 0 !important; padding: 0 !important; display: inline-flex !important; align-items: center !important; }
          .video-preview-modal .modal-header .btn-close { margin: 0 !important; padding: 8px !important; align-self: center !important; }
          .video-preview-modal .vp-title { font-size: 14px; font-weight: 700; color: #0f172a; letter-spacing: -0.01em; line-height: 1; }
          .video-preview-modal .modal-body { padding: 16px 20px; background: #f8fafc; }
          .video-preview-modal .vp-video-frame {
            border: 1px solid #e5e7eb;
            border-radius: 10px;
            overflow: hidden;
            background: #000;
            height: 300px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 14px;
          }
          .video-preview-modal .vp-video-empty {
            border: 1px dashed #cbd5e1;
            border-radius: 10px;
            background: #fff;
            height: 300px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 6px;
            color: #94a3b8;
            text-align: center;
            padding: 20px;
            margin-bottom: 14px;
          }
          .video-preview-modal .vp-video-empty p { margin: 0; font-size: 12px; color: #64748b; }
          .video-preview-modal .vp-info-block {
            padding: 12px 14px;
            background: #fff;
            border: 1px solid #e2e8f0;
            border-radius: 10px;
          }
          .video-preview-modal .vp-info-row { display: flex; gap: 8px; align-items: flex-start; }
          .video-preview-modal .vp-info-row + .vp-info-row { margin-top: 8px; }
          .video-preview-modal .vp-info-label {
            flex-shrink: 0;
            font-size: 10px;
            font-weight: 600;
            color: #64748b;
            text-transform: uppercase;
            letter-spacing: 0.04em;
            min-width: 72px;
            padding-top: 2px;
          }
          .video-preview-modal .vp-info-value {
            font-size: 12px;
            font-weight: 500;
            color: #0f172a;
            line-height: 1.45;
            word-wrap: break-word;
            overflow-wrap: anywhere;
          }
          .video-preview-modal .vp-info-empty { color: #94a3b8; font-weight: 400; font-style: italic; }
          .video-preview-modal .modal-footer {
            display: flex !important;
            align-items: center !important;
            justify-content: flex-end !important;
            padding: 10px 16px !important;
            min-height: 54px !important;
            border-top: 1px solid #e5e7eb;
            background: #fff;
            gap: 8px;
          }
          .video-preview-modal .modal-footer > * { margin: 0 !important; }
          .video-preview-modal .vp-btn {
            padding: 6px 16px;
            height: 34px;
            border-radius: 6px;
            font-size: 12px;
            font-weight: 700;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            cursor: pointer;
            transition: all 0.15s ease;
          }
          .video-preview-modal .vp-btn-reject { border: 1px solid #fecdd3; background: #fff1f2; color: #be123c; }
          .video-preview-modal .vp-btn-reject:hover { background: #ffe4e6; }
          .video-preview-modal .vp-btn-accept { border: 0; background: #008695; color: #fff; box-shadow: 0 3px 8px rgba(0, 134, 149, 0.22); }
          .video-preview-modal .vp-btn-accept:hover { background: #007784; }
          @media (max-width: 575.98px) {
            .video-preview-modal .modal-dialog { margin: 8px; max-width: none; }
            .video-preview-modal .vp-video-frame,
            .video-preview-modal .vp-video-empty { height: 220px; }
          }
        `}</style>
        <Modal.Header closeButton>
          <Modal.Title as="span" className="vp-title">
            {videoPreviewData.orderType === 2 ? 'Exchange' : videoPreviewData.orderType === 1 ? 'Return' : ''} Evidence · {videoPreviewData.orderId}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {videoPreviewData.videoUrl ? (
            <div className="vp-video-frame">
              <video
                key={videoPreviewData.videoUrl}
                controls
                autoPlay
                muted
                playsInline
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              >
                <source src={videoPreviewData.videoUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          ) : (
            <div className="vp-video-empty">
              <FiImage size={32} />
              <p>No evidence video available</p>
            </div>
          )}
          <div className="vp-info-block">
            <div className="vp-info-row">
              <span className="vp-info-label">Reason</span>
              <span className={`vp-info-value${videoPreviewData.reason ? '' : ' vp-info-empty'}`}>
                {videoPreviewData.reason || 'Not provided'}
              </span>
            </div>
            <div className="vp-info-row">
              <span className="vp-info-label">Comment</span>
              <span className={`vp-info-value${videoPreviewData.comments ? '' : ' vp-info-empty'}`}>
                {videoPreviewData.comments || 'No comment provided'}
              </span>
            </div>
          </div>
        </Modal.Body>
        {videoPreviewData?.row && (
          <Modal.Footer>
            <button type="button" className="vp-btn vp-btn-reject" onClick={handleVideoPreviewReject}>
              <FiX size={13} />
              Reject
            </button>
            <button type="button" className="vp-btn vp-btn-accept" onClick={handleVideoPreviewAccept}>
              Accept
            </button>
          </Modal.Footer>
        )}
      </Modal>

      {/* Evidence Check Modal (shared UX with OrderDetails / Dashboard) */}
      <Modal
        show={showEvidenceModal}
        onHide={closeEvidenceModal}
        centered
        size="lg"
        dialogClassName="evidence-modal"
        backdrop={evidenceLoading ? 'static' : true}
        keyboard={!evidenceLoading}
      >
        <style>{`
          .evidence-modal .modal-dialog { max-width: 720px; }
          .evidence-modal .modal-content { border: 0; border-radius: 12px; overflow: hidden; }
          .evidence-modal .modal-header { padding: 14px 20px !important; border-bottom: 1px solid #e5e7eb; }
          .evidence-modal .modal-header .modal-title { margin: 0 !important; padding: 0 !important; display: inline-flex; align-items: center; }
          .evidence-modal .modal-header .btn-close { margin: 0 !important; padding: 8px !important; font-size: 12px; align-self: center; }
          .evidence-modal .modal-body { padding: 0; max-height: 68vh; overflow-y: auto; }
          .evidence-modal .modal-footer { padding: 10px 16px; border-top: 1px solid #e5e7eb; background: #f8fafc; }
          .evidence-modal .evidence-title { display: inline-block; margin: 0; padding: 0; font-size: 14px; font-weight: 700; color: #0f172a; letter-spacing: -0.01em; line-height: 1.2; vertical-align: middle; }
          .evidence-modal .evidence-col-left { padding: 14px 16px; border-right: 1px solid #e5e7eb; background: #fff; }
          .evidence-modal .evidence-col-right { padding: 14px 16px; background: #f8fafc; }
          .evidence-modal .evidence-section-label { margin: 0 0 8px; font-size: 12px; font-weight: 600; color: #0f172a; }
          .evidence-modal .evidence-customer-block {
            margin: 0 0 14px;
            padding: 10px 12px;
            background: #f8fafc;
            border: 1px solid #e2e8f0;
            border-radius: 8px;
          }
          .evidence-modal .evidence-customer-row { display: flex; gap: 6px; align-items: flex-start; }
          .evidence-modal .evidence-customer-row + .evidence-customer-row { margin-top: 6px; }
          .evidence-modal .evidence-customer-label { flex-shrink: 0; font-size: 10px; font-weight: 600; color: #64748b; text-transform: uppercase; letter-spacing: 0.04em; min-width: 66px; padding-top: 1px; }
          .evidence-modal .evidence-customer-value { font-size: 11.5px; font-weight: 500; color: #0f172a; line-height: 1.45; word-wrap: break-word; overflow-wrap: anywhere; }
          .evidence-modal .evidence-field-label { margin: 12px 0 4px; font-size: 11px; font-weight: 500; color: #475569; }
          .evidence-modal .evidence-select,
          .evidence-modal .evidence-textarea { font-size: 11px !important; border-radius: 6px !important; border: 1px solid #cbd5e1 !important; padding: 7px 10px !important; color: #0f172a; }
          .evidence-modal .evidence-textarea { min-height: 84px !important; resize: vertical; }
          .evidence-modal .evidence-select:focus,
          .evidence-modal .evidence-textarea:focus { border-color: #0e7490 !important; box-shadow: 0 0 0 3px rgba(14, 116, 144, 0.1) !important; }
          .evidence-modal .evidence-counter { margin-top: 4px; font-size: 10px; text-align: right; color: #94a3b8; }
          .evidence-modal .evidence-counter.is-ok { color: #16a34a; }
          .evidence-modal .evidence-video-frame { border: 1px solid #e5e7eb; border-radius: 8px; overflow: hidden; background: #000; height: 260px; display: flex; align-items: center; justify-content: center; }
          .evidence-modal .evidence-video-empty { border: 1px dashed #cbd5e1; border-radius: 8px; background: #fff; height: 260px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; color: #94a3b8; text-align: center; padding: 16px; }
          .evidence-modal .evidence-video-empty p { margin: 0; font-size: 11px; color: #64748b; }
          .evidence-modal .evidence-btn { border-radius: 6px !important; padding: 6px 14px !important; font-size: 12px !important; font-weight: 600 !important; min-width: 88px; display: inline-flex; align-items: center; justify-content: center; gap: 6px; }
          @media (max-width: 767.98px) {
            .evidence-modal .modal-dialog { margin: 8px; max-width: none; }
            .evidence-modal .modal-body { max-height: calc(100vh - 200px); }
            .evidence-modal .evidence-col-left { border-right: 0; border-bottom: 1px solid #e5e7eb; padding: 12px 14px; }
            .evidence-modal .evidence-col-right { padding: 12px 14px; }
            .evidence-modal .evidence-video-frame,
            .evidence-modal .evidence-video-empty { height: 200px; }
            .evidence-modal .evidence-title { font-size: 13px; }
            .evidence-modal .modal-footer { padding: 10px 12px; gap: 8px; }
            .evidence-modal .evidence-btn { flex: 1; min-width: 0; padding: 8px 10px !important; font-size: 11px !important; }
          }
        `}</style>

        <Modal.Header closeButton>
          <Modal.Title as="span" className="evidence-title">
            Check {evidenceOrder?.orderType === 1 ? 'Return' : evidenceOrder?.orderType === 2 ? 'Exchange' : ''} Evidence
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row g-0">
            <div className="col-md-6 evidence-col-left">
              {(evidenceReturnReason || evidenceReturnComments) && (
                <div className="evidence-customer-block">
                  {evidenceReturnReason && (
                    <div className="evidence-customer-row">
                      <span className="evidence-customer-label">Reason</span>
                      <span className="evidence-customer-value">{evidenceReturnReason}</span>
                    </div>
                  )}
                  {evidenceReturnComments && (
                    <div className="evidence-customer-row">
                      <span className="evidence-customer-label">Comment</span>
                      <span className="evidence-customer-value">{evidenceReturnComments}</span>
                    </div>
                  )}
                </div>
              )}
              <h6 className="evidence-section-label">Rejection Reason</h6>
              <Form.Group>
                <Form.Select
                  className="evidence-select"
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  disabled={evidenceLoading}
                >
                  <option value="">Choose a rejection reason...</option>
                  {EVIDENCE_REJECTION_REASONS.map((reason, index) => (
                    <option key={index} value={reason}>{reason}</option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group>
                <Form.Label className="evidence-field-label">Any other reason</Form.Label>
                <Form.Control
                  as="textarea"
                  className="evidence-textarea"
                  rows={4}
                  placeholder="Provide specific reason for rejection (minimum 10 characters)..."
                  value={customReason}
                  onChange={(e) => setCustomReason(e.target.value)}
                  disabled={evidenceLoading}
                />
                <div className={`evidence-counter${customReason && customReason.trim().length >= 10 ? ' is-ok' : ''}`}>
                  {customReason?.length || 0}/10 characters
                  {customReason && customReason.trim().length >= 10 && ' ✓'}
                </div>
              </Form.Group>
            </div>

            <div className="col-md-6 evidence-col-right">
              {evidenceVideoUrl ? (
                <div className="evidence-video-frame">
                  <video
                    key={evidenceVideoUrl}
                    controls
                    autoPlay
                    muted
                    playsInline
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  >
                    <source src={evidenceVideoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              ) : (
                <div className="evidence-video-empty">
                  <FiImage size={30} />
                  <p>No evidence video available</p>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="danger"
            className="evidence-btn"
            onClick={handleEvidenceReject}
            disabled={evidenceLoading || !(rejectionReason || (customReason && customReason.trim().length >= 10))}
          >
            {evidenceAction === 'REJECT' ? (<><Spinner as="span" animation="border" size="sm" /> Processing...</>) : 'Reject'}
          </Button>
          <Button
            variant="success"
            className="evidence-btn"
            onClick={handleEvidenceApprove}
            disabled={evidenceLoading || (rejectionReason || (customReason.trim().length > 0))}
          >
            {evidenceAction === 'APPROVE' ? (<><Spinner as="span" animation="border" size="sm" /> Processing...</>) : 'Confirm'}
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
}


export default Orders
